import React, { useState } from "react";
import { Card, Button, Collapse } from "react-bootstrap";

function CodingProblem({ problem, expectedSolution, explanation, index }) {
  const [showSolution, setShowSolution] = useState(false);

  const handleReveal = () => setShowSolution(!showSolution);

  return (
    <Card className="coding-problem-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title>{index}. Coding Problem</Card.Title>
        <Card.Text>
          <strong>Problem:</strong> {problem}
        </Card.Text>
        <Button variant="primary" onClick={handleReveal}>
          {showSolution ? "Hide Solution" : "Reveal Solution"}
        </Button>
        <Collapse in={showSolution}>
          <div>
            <Card.Text className="mt-3">
              <strong>Expected Solution:</strong>
              <pre>{expectedSolution}</pre>
            </Card.Text>
            <Card.Text>
              <strong>Explanation:</strong> {explanation}
            </Card.Text>
          </div>
        </Collapse>
      </Card.Body>
    </Card>
  );
}

export default CodingProblem;
